// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3f-El","ranges":"BmiRanges_ranges__3Aj9P"};